import React from "react";
import { useLocation } from "react-router-dom";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import ExportPhysiotherapyData from "./ExportPhysiotherapyData";

const SelectExportPhysiotherapyData = () => {
  const { state } = useLocation();
  let selectedData = state.data;
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes
        page="ExportPhysiotherapyData"
        route="/export/physiotherapy"
      >
        {/* {JSON.stringify(selectedData)} */}
        <ExportPhysiotherapyData jsonData={selectedData} />
      </ErrorBoundaryRoutes>
      {/* {JSON.stringify(selectedData)} */}
    </MainContentCard>
  );
};

export default SelectExportPhysiotherapyData;
